import { motion, AnimatePresence } from "framer-motion";
import { useState, useEffect } from "react";
import { ChevronLeft, ChevronRight, TrendingUp, Award, Target, Lock } from "lucide-react";

const CASOS = [
  {
    id: "nereida",
    locked: false,
    name: "Nereida Peña",
    rank: "Ranger",
    country: "🇻🇪 Venezuela",
    since: "Enero 2026",
    photo: "https://customer-assets.emergentagent.com/job_honor-platform-2/artifacts/k030pwhk_foto%20de%20nereida%20pe%C3%B1a.jpeg",
    headline: "De estudiante a trader fondeada en 4 meses.",
    quote:
      "Entré a Honor sin saber leer un gráfico. En 4 meses pasé mi fase 1 de fondeo de $8.000 USD y sigo sumando operaciones positivas cada semana.",
    stats: {
      fondeo: "$8.000",
      totalProfit: 424.52,
      profitPlus: false,
      winTrades: 7,
      totalTrades: 8,
    },
    trades: [
      {
        pair: "GBPUSD · XAUUSD · EURUSD",
        label: "Cuenta Fondeada",
        beneficio: "+$75.46",
        balance: "$8.075,05",
        extra: "Paprika Sweet 12K · Phase 1",
        img: "https://customer-assets.emergentagent.com/job_honor-platform-2/artifacts/71hl07e3_3.jpeg",
        color: "mindaro",
      },
      {
        pair: "XAUUSD · USDJPY · GBPUSD",
        label: "Sesión ganadora",
        beneficio: "+$184.51",
        balance: "$183,61",
        extra: "3 operaciones ejecutadas",
        img: "https://customer-assets.emergentagent.com/job_honor-platform-2/artifacts/8jdqpjzs_4.jpeg",
        color: "mindaro",
      },
      {
        pair: "XAUUSD",
        label: "Operación Gold",
        beneficio: "+$99.00",
        balance: "$99,00",
        extra: "Buy 0.02 · 4678 → 4727",
        img: "https://customer-assets.emergentagent.com/job_honor-platform-2/artifacts/mp8z7b9o_1.jpeg",
        color: "mindaro",
      },
      {
        pair: "GBPUSD · EURUSD",
        label: "Doble winner",
        beneficio: "+$65.55",
        balance: "$63,15",
        extra: "GBPUSD +$52.35 · EURUSD +$13.20",
        img: "https://customer-assets.emergentagent.com/job_honor-platform-2/artifacts/dnt938x5_2.jpeg",
        color: "mindaro",
      },
    ],
  },
  {
    id: "jose-chirinos",
    locked: false,
    name: "José Chirinos",
    rank: "Founder · CEO",
    country: "🇻🇪 Venezuela",
    since: "Fundador · 12 años trading",
    photo: "https://customer-assets.emergentagent.com/job_honor-platform-2/artifacts/96gogbnu_de%20lado%20guaji.png",
    headline: "CEO & fundador. +$14M USD gestionados. +$5M en ganancias.",
    quote:
      "Empecé hace 12 años operando una cuenta personal. Hoy lidero un ecosistema que ha gestionado más de $14 millones USD en fondos de inversión y acumulado más de $5 millones USD en ganancias propias. Honor Trading nació para enseñar lo que el trading real requiere: disciplina militar.",
    stats: {
      fondeo: "$14M+",
      totalProfit: 5000000,
      profitPlus: true,
      winTrades: 2847,
      totalTrades: 3200,
    },
    trades: [
      {
        pair: "XAUUSD",
        label: "Cuenta institucional $1M",
        beneficio: "+$202.280",
        balance: "$1.191.620",
        extra: "Buy 20 lotes · XAUUSD +$153K + $48K",
        img: "https://customer-assets.emergentagent.com/job_honor-platform-2/artifacts/5qffadgt_3.jpeg",
        color: "mindaro",
      },
      {
        pair: "XAUUSD · BTCUSD",
        label: "Cuenta $1.2M",
        beneficio: "+$217.773",
        balance: "$1.404.134",
        extra: "3 trades XAU + BTC · Balance final $1.4M",
        img: "https://customer-assets.emergentagent.com/job_honor-platform-2/artifacts/5tgq3wgy_4.jpeg",
        color: "mindaro",
      },
      {
        pair: "Portfolio BTC Spot",
        label: "Billetera cripto",
        beneficio: "+$27.834",
        balance: "$2.344.678",
        extra: "38.41 BTC · PNL diario +13.07%",
        img: "https://customer-assets.emergentagent.com/job_honor-platform-2/artifacts/sou6dovp_1.jpeg",
        color: "mindaro",
      },
      {
        pair: "XAUUSD",
        label: "Buy 20 · 153K profit",
        beneficio: "+$153.300",
        balance: "$1.000.000",
        extra: "Entry 4667 → 4744 · +76 puntos",
        img: "https://customer-assets.emergentagent.com/job_honor-platform-2/artifacts/0u0lmsvj_2.jpeg",
        color: "mindaro",
      },
      {
        pair: "XAUUSD",
        label: "Cuenta $500K",
        beneficio: "+$192.765",
        balance: "$677.840",
        extra: "Profit acumulado · Withdrawal $5.3K",
        img: "https://customer-assets.emergentagent.com/job_honor-platform-2/artifacts/ctqrscuf_5.jpeg",
        color: "mindaro",
      },
      {
        pair: "XAUUSD · EURUSD",
        label: "Scalping 21 lotes",
        beneficio: "+$10.656",
        balance: "Sesión",
        extra: "5 trades ejecutados en 5 minutos",
        img: "https://customer-assets.emergentagent.com/job_honor-platform-2/artifacts/c46jfpgw_6.jpeg",
        color: "mindaro",
      },
    ],
  },
  {
    id: "juan-esteban",
    locked: false,
    name: "Juan Esteban Sánchez",
    rank: "Delta",
    country: "🇨🇴 Colombia",
    since: "Enero 2025",
    photo: "https://customer-assets.emergentagent.com/job_honor-platform-2/artifacts/id6l4nwv_juan%20esteban%20sanchez.jpeg",
    headline: "Fondeado con $200K y +$30.000 USD en ganancias.",
    quote:
      "Desde enero 2025 sigo el sistema Honor al pie de la letra. Escalé hasta manejar cuenta fondeada de $200.000 USD y superé los $30.000 USD en ganancias acumuladas. El mejor nivel al que un trader puede aspirar.",
    stats: {
      fondeo: "$200.000",
      totalProfit: 30000,
      profitPlus: true,
      winTrades: 230,
      totalTrades: 260,
    },
    trades: [
      {
        pair: "XAUUSD",
        label: "Cuenta $50K",
        beneficio: "+$820.72",
        balance: "$50.302,07",
        extra: "Histórico de 12 trades XAUUSD",
        img: "https://customer-assets.emergentagent.com/job_honor-platform-2/artifacts/7fzr0oz4_1.jpeg",
        color: "mindaro",
      },
      {
        pair: "USDJPYc",
        label: "Doble JPY",
        beneficio: "+$316.05",
        balance: "$5.533,63",
        extra: "2 sell 0.2 · +$126.56 + $189.49",
        img: "https://customer-assets.emergentagent.com/job_honor-platform-2/artifacts/iaw45s4i_2.jpeg",
        color: "mindaro",
      },
      {
        pair: "XAUUSD",
        label: "Macro Gold",
        beneficio: "+€749.26",
        balance: "€5.798,81",
        extra: "Sell 0.2 · 3307 → 3263 · cuenta EUR",
        img: "https://customer-assets.emergentagent.com/job_honor-platform-2/artifacts/4gibhjr9_3.jpeg",
        color: "mindaro",
      },
    ],
  },
  { id: "caso-2", locked: false, name: "Nelson Toro", rank: "Charlie", country: "🇨🇴 Colombia", since: "Julio 2025",
    photo: "https://customer-assets.emergentagent.com/job_honor-platform-2/artifacts/3as6ld3d_nelsontoro.png",
    headline: "Fondeado con $15K y +100 trades ejecutados.",
    quote:
      "Entré a Honor en julio 2025 buscando seriedad, no vendehumos. Hoy opero con cuenta fondeada de $15.000 USD, más de 100 operaciones ejecutadas y más de $3.000 USD en ganancias acumuladas.",
    stats: {
      fondeo: "$15.000",
      totalProfit: 3000,
      profitPlus: true,
      winTrades: 100,
      totalTrades: 115,
    },
    trades: [
      {
        pair: "XAUUSD",
        label: "Sesión Gold ganadora",
        beneficio: "+$274.63",
        balance: "$169.72",
        extra: "3 operaciones XAUUSD seguidas",
        img: "https://customer-assets.emergentagent.com/job_honor-platform-2/artifacts/jh7rm04x_WhatsApp%20Image%202026-04-20%20at%201.26.39%20AM.jpeg",
        color: "mindaro",
      },
      {
        pair: "DJIUSD · XAUUSD",
        label: "Multi-setup",
        beneficio: "+$91.98",
        balance: "Histórico",
        extra: "7 trades ganadores consecutivos",
        img: "https://customer-assets.emergentagent.com/job_honor-platform-2/artifacts/pv7noxd8_4.jpeg",
        color: "mindaro",
      },
      {
        pair: "GBPJPY · USDJPY",
        label: "Doble JPY",
        beneficio: "+$20.14",
        balance: "Intraday",
        extra: "GBPJPY +$6.57 · USDJPY +$13.57",
        img: "https://customer-assets.emergentagent.com/job_honor-platform-2/artifacts/r534a24x_3.jpeg",
        color: "mindaro",
      },
      {
        pair: "XAUUSD",
        label: "Scalping Gold",
        beneficio: "+$41.14",
        balance: "Sesión",
        extra: "6 entradas precisas · 5 ganadoras",
        img: "https://customer-assets.emergentagent.com/job_honor-platform-2/artifacts/nrwprq3q_WhatsApp%20Image%202026-04-20%20at%201.26.40%20AM.jpeg",
        color: "mindaro",
      },
    ],
  },
  {
    id: "caso-4",
    locked: false,
    name: "Moisés Rodríguez",
    rank: "Tango",
    country: "🇻🇪 Venezuela",
    since: "Septiembre 2025",
    photo: "https://customer-assets.emergentagent.com/job_honor-platform-2/artifacts/jplakdqn_moi.jpeg",
    headline: "De cero a cuenta fondeada de $15K en 7 meses.",
    quote:
      "Llegué a Honor en septiembre 2025 sin experiencia previa. Aplicando el método disciplinado de la academia, pasé mi fondeo de $15.000 USD y mi mejor operación individual fue de $563 USD en una sola entrada.",
    stats: {
      fondeo: "$15.000",
      totalProfit: 1263.8,
      profitPlus: true,
      winTrades: 38,
      totalTrades: 42,
    },
    trades: [
      {
        pair: "XAUUSD",
        label: "Entrada monstruosa",
        beneficio: "+$563.70",
        balance: "$551.32",
        extra: "Buy 0.10 · 5192 → 5248",
        img: "https://customer-assets.emergentagent.com/job_honor-platform-2/artifacts/9d38kg0k_1.jpeg",
        color: "mindaro",
      },
      {
        pair: "USDCAD",
        label: "Cuenta $5K",
        beneficio: "+$77.54",
        balance: "$5.149,15",
        extra: "2 posiciones USDCAD sell activas",
        img: "https://customer-assets.emergentagent.com/job_honor-platform-2/artifacts/ntpsgxgv_4.jpeg",
        color: "mindaro",
      },
      {
        pair: "GBPUSD · XAUUSD",
        label: "Doble winner",
        beneficio: "+$66.10",
        balance: "$64.60",
        extra: "GBPUSD +$35.50 · XAUUSD +$30.60",
        img: "https://customer-assets.emergentagent.com/job_honor-platform-2/artifacts/jcazw4zu_3.jpeg",
        color: "mindaro",
      },
      {
        pair: "XAUUSD",
        label: "Scalping Gold",
        beneficio: "+$56.40",
        balance: "$56.40",
        extra: "Sell 0.05 · 5214 → 5203",
        img: "https://customer-assets.emergentagent.com/job_honor-platform-2/artifacts/orufnwy0_2.jpeg",
        color: "mindaro",
      },
    ],
  },
  {
    id: "daniel-masa",
    locked: false,
    name: "Daniel Masa",
    rank: "Ranger",
    country: "🇻🇪 Venezuela",
    since: "Noviembre 2025",
    photo: "https://customer-assets.emergentagent.com/job_honor-platform-2/artifacts/32j648h4_daniel.jpeg",
    headline: "Fondeado con $50K y +$7.000 USD en 5 meses.",
    quote:
      "Entré a Honor en noviembre 2025 con cero experiencia. Siguiendo la metodología al pie de la letra pasé mi fondeo de $50.000 USD y acumulé más de $7.000 USD operando XAUUSD con precisión quirúrgica.",
    stats: {
      fondeo: "$50.000",
      totalProfit: 7000,
      profitPlus: true,
      winTrades: 45,
      totalTrades: 52,
    },
    trades: [
      {
        pair: "XAUUSD",
        label: "Buy 0.2 · Mega winner",
        beneficio: "+$3.490,60",
        balance: "Intraday",
        extra: "4678.42 → 4852.95 · +174 puntos",
        img: "https://customer-assets.emergentagent.com/job_honor-platform-2/artifacts/wkzs9dnb_1.jpeg",
        color: "mindaro",
      },
      {
        pair: "XAUUSD",
        label: "Buy 0.1 · Long run",
        beneficio: "+$1.790,90",
        balance: "Intraday",
        extra: "4674.85 → 4853.94 · +179 puntos",
        img: "https://customer-assets.emergentagent.com/job_honor-platform-2/artifacts/lxztn4rk_2.jpeg",
        color: "mindaro",
      },
      {
        pair: "XAUUSD",
        label: "Buy 0.1 · Swing Gold",
        beneficio: "+$1.706,10",
        balance: "Swing",
        extra: "4629.05 → 4799.66 · +170 puntos",
        img: "https://customer-assets.emergentagent.com/job_honor-platform-2/artifacts/pm9bqq89_3.jpeg",
        color: "mindaro",
      },
    ],
  },
];

// Animated counter
const Counter = ({ to, prefix = "", suffix = "", duration = 1.5 }) => {
  const [val, setVal] = useState(0);
  useEffect(() => {
    const start = performance.now();
    let raf;
    const tick = (t) => {
      const p = Math.min((t - start) / (duration * 1000), 1);
      const eased = 1 - Math.pow(1 - p, 3);
      setVal(to * eased);
      if (p < 1) raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [to, duration]);
  return (
    <span>
      {prefix}
      {val.toLocaleString("en-US", { minimumFractionDigits: to % 1 === 0 ? 0 : 2, maximumFractionDigits: 2 })}
      {suffix}
    </span>
  );
};

export default function CasosExito() {
  const [activeIdx, setActiveIdx] = useState(0);
  const caso = CASOS[activeIdx];

  const prev = () => setActiveIdx((i) => (i === 0 ? CASOS.length - 1 : i - 1));
  const next = () => setActiveIdx((i) => (i === CASOS.length - 1 ? 0 : i + 1));

  return (
    <section
      id="casos-exito"
      className="relative py-24 md:py-32 bg-black overflow-hidden"
      data-testid="casos-exito-section"
    >
      <div className="absolute inset-0 radial-green opacity-40 pointer-events-none" />
      <div className="absolute inset-0 grid-bg opacity-30 pointer-events-none" />

      <div className="relative max-w-7xl mx-auto px-6 md:px-10">
        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-12">
          <div className="max-w-2xl">
            <span className="text-xs font-display uppercase tracking-[0.4em] text-[#BEDD7D]">
              / Casos de Éxito
            </span>
            <h2 className="mt-6 font-display font-bold text-4xl md:text-6xl uppercase tracking-tight leading-none">
              Resultados <span className="italic text-[#BEDD7D]">reales</span>.
              <br />
              Capturas reales.
            </h2>
            <p className="mt-5 text-white/60 font-body">
              Traders que pasaron de Recluta a cuentas fondeadas. Screenshots directos de sus
              operaciones.
            </p>
          </div>

          {/* Case navigation pills */}
          <div className="flex items-center gap-2" data-testid="casos-nav">
            {CASOS.map((c, i) => (
              <button
                key={c.id}
                onClick={() => !c.locked && setActiveIdx(i)}
                disabled={c.locked}
                className={`relative h-2 rounded-full transition-all ${
                  i === activeIdx
                    ? "w-12 bg-[#BEDD7D]"
                    : c.locked
                    ? "w-2 bg-white/10 cursor-not-allowed"
                    : "w-8 bg-white/30 hover:bg-white/60"
                }`}
                aria-label={`Caso ${i + 1}`}
                data-testid={`caso-dot-${i}`}
              />
            ))}
          </div>
        </div>

        {/* Main card */}
        <AnimatePresence mode="wait">
          <motion.div
            key={caso.id}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -20 }}
            transition={{ duration: 0.5 }}
            className="relative rounded-3xl border border-[#3E4D36]/60 bg-gradient-to-br from-[#1A2E1A]/40 to-black overflow-hidden"
            data-testid={`caso-card-${caso.id}`}
          >
            {caso.locked ? (
              <div className="flex flex-col items-center justify-center py-32 px-6 text-center">
                <div className="w-16 h-16 rounded-full bg-[#1A2E1A] border border-[#BEDD7D]/30 flex items-center justify-center">
                  <Lock className="w-6 h-6 text-[#BEDD7D]/60" />
                </div>
                <h3 className="mt-6 font-display font-bold text-3xl uppercase tracking-tight text-white/70">
                  Próximo caso
                </h3>
                <p className="mt-3 text-white/50 font-body">
                  Nuevo testimonio próximamente. Guarda la página.
                </p>
              </div>
            ) : (
              <div className="grid lg:grid-cols-5 gap-0">
                {/* Left: video-like portrait */}
                <div className="relative lg:col-span-2 aspect-square lg:aspect-auto min-h-[400px] overflow-hidden bg-black">
                  <img
                    src={caso.photo}
                    alt={caso.name}
                    className="absolute inset-0 w-full h-full object-cover"
                    loading="lazy"
                  />
                  {/* Vignette */}
                  <div className="absolute inset-0 bg-gradient-to-t from-black via-black/20 to-transparent" />
                  <div className="absolute inset-0 bg-gradient-to-r from-transparent via-transparent to-black/40 lg:to-black/60" />

                  {/* Fake video HUD */}
                  <div className="absolute top-5 left-5 right-5 flex items-center justify-between">
                    <div className="flex items-center gap-2 px-3 py-1 bg-red-500/20 border border-red-500/60 rounded-full backdrop-blur-md">
                      <span className="w-1.5 h-1.5 rounded-full bg-red-500 animate-pulse" />
                      <span className="text-[10px] font-display uppercase tracking-widest text-red-400 font-bold">
                        REC
                      </span>
                    </div>
                    <div className="text-[10px] font-display uppercase tracking-widest text-white/70">
                      CASO 0{activeIdx + 1}
                    </div>
                  </div>

                  {/* Bottom identity bar */}
                  <div className="absolute bottom-0 left-0 right-0 p-5 md:p-7 bg-gradient-to-t from-black via-black/70 to-transparent">
                    <div className="text-[10px] font-display uppercase tracking-[0.3em] text-[#BEDD7D] mb-2">
                      {caso.rank} · {caso.country}
                    </div>
                    <div className="font-display font-bold text-2xl md:text-3xl uppercase tracking-tight text-white">
                      {caso.name}
                    </div>
                    <div className="mt-1 text-xs text-white/50 font-body">
                      En Honor Trading desde {caso.since}
                    </div>
                  </div>

                  {/* Scanline animation */}
                  <motion.div
                    className="absolute inset-x-0 h-[1px] bg-[#BEDD7D]/60 pointer-events-none"
                    animate={{ y: [0, "100%", 0] }}
                    transition={{ duration: 6, repeat: Infinity, ease: "linear" }}
                    style={{ boxShadow: "0 0 20px rgba(190,221,125,0.8)" }}
                  />
                </div>

                {/* Right: story + stats */}
                <div className="lg:col-span-3 p-7 md:p-10 flex flex-col">
                  <h3 className="font-display font-bold text-2xl md:text-4xl uppercase tracking-tight leading-tight text-white">
                    {caso.headline}
                  </h3>
                  <p className="mt-5 text-white/75 font-body leading-relaxed text-[15px] md:text-base italic">
                    "{caso.quote}"
                  </p>

                  {/* Stats grid */}
                  <div className="mt-8 grid grid-cols-2 md:grid-cols-4 gap-3">
                    <div className="p-4 rounded-xl bg-[#1A2E1A]/60 border border-[#BEDD7D]/40" data-testid="stat-fondeo">
                      <div className="flex items-center gap-2 text-[10px] font-display uppercase tracking-widest text-white/50">
                        <Award className="w-3 h-3 text-[#BEDD7D]" />
                        Fondeo
                      </div>
                      <div className="mt-1 font-display font-bold text-2xl text-[#BEDD7D]">
                        {caso.stats.fondeo}
                      </div>
                    </div>
                    <div className="p-4 rounded-xl bg-[#1A2E1A]/60 border border-[#3E4D36]/50" data-testid="stat-profit">
                      <div className="flex items-center gap-2 text-[10px] font-display uppercase tracking-widest text-white/50">
                        <TrendingUp className="w-3 h-3 text-[#BEDD7D]" />
                        Profit total
                      </div>
                      <div className="mt-1 font-display font-bold text-2xl text-white">
                        <Counter to={caso.stats.totalProfit} prefix="$" />
                        {caso.stats.profitPlus && <span className="text-[#BEDD7D]">+</span>}
                      </div>
                    </div>
                    <div className="p-4 rounded-xl bg-[#1A2E1A]/60 border border-[#3E4D36]/50" data-testid="stat-winrate">
                      <div className="flex items-center gap-2 text-[10px] font-display uppercase tracking-widest text-white/50">
                        <Target className="w-3 h-3 text-[#BEDD7D]" />
                        Win rate
                      </div>
                      <div className="mt-1 font-display font-bold text-2xl text-white">
                        <Counter to={Math.round((caso.stats.winTrades / caso.stats.totalTrades) * 100)} suffix="%" duration={1.2} />
                      </div>
                    </div>
                    <div className="p-4 rounded-xl bg-[#1A2E1A]/60 border border-[#3E4D36]/50" data-testid="stat-trades">
                      <div className="flex items-center gap-2 text-[10px] font-display uppercase tracking-widest text-white/50">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="w-3 h-3 text-[#BEDD7D]"><path d="M3 3v18h18"/><path d="m7 14 4-4 4 4 6-6"/></svg>
                        Trades
                      </div>
                      <div className="mt-1 font-display font-bold text-2xl text-white">
                        {caso.stats.winTrades}<span className="text-white/40">/{caso.stats.totalTrades}</span>
                      </div>
                    </div>
                  </div>

                  {/* Trade screenshots — like video thumbnails */}
                  <div className="mt-8">
                    <div className="flex items-center justify-between mb-4">
                      <div className="text-[11px] font-display uppercase tracking-[0.25em] text-white/50">
                        Screenshots de sus operaciones
                      </div>
                      <div className="hidden md:flex items-center gap-1">
                        <div className="w-1 h-1 rounded-full bg-[#BEDD7D]" />
                        <div className="w-1 h-1 rounded-full bg-white/30" />
                        <div className="w-1 h-1 rounded-full bg-white/30" />
                        <div className="w-1 h-1 rounded-full bg-white/30" />
                      </div>
                    </div>
                    <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
                      {caso.trades.map((t, i) => (
                        <motion.a
                          key={i}
                          href={t.img}
                          target="_blank"
                          rel="noopener noreferrer"
                          initial={{ opacity: 0, y: 20 }}
                          whileInView={{ opacity: 1, y: 0 }}
                          viewport={{ once: true }}
                          transition={{ duration: 0.4, delay: 0.1 * i }}
                          className="group relative block rounded-xl overflow-hidden border border-[#3E4D36]/50 hover:border-[#BEDD7D]/60 transition-all bg-black"
                          data-testid={`trade-thumb-${i}`}
                        >
                          <div className="aspect-square overflow-hidden">
                            <img
                              src={t.img}
                              alt={t.label}
                              className="w-full h-full object-cover opacity-80 group-hover:opacity-100 group-hover:scale-105 transition-all duration-500"
                              loading="lazy"
                            />
                          </div>
                          <div className="absolute inset-0 bg-gradient-to-t from-black via-black/30 to-transparent" />
                          <div className="absolute top-2 right-2 px-2 py-0.5 rounded-md bg-[#BEDD7D] text-black text-[10px] font-display font-bold">
                            {t.beneficio}
                          </div>
                          <div className="absolute bottom-0 left-0 right-0 p-3">
                            <div className="text-[9px] font-display uppercase tracking-widest text-[#BEDD7D]">
                              {t.label}
                            </div>
                            <div className="text-[11px] font-body text-white/90 truncate mt-0.5">
                              {t.pair}
                            </div>
                          </div>
                        </motion.a>
                      ))}
                    </div>
                  </div>

                  {/* Footer CTA */}
                  <div className="mt-8 pt-6 border-t border-[#3E4D36]/40 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
                    <div className="text-xs font-body text-white/50">
                      Verificado por screenshots directos de la cuenta del estudiante.
                    </div>
                    <a
                      href="https://app.honor.trading/auth/login"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="inline-flex items-center gap-2 px-5 py-2.5 bg-[#BEDD7D] text-black font-display font-bold text-xs uppercase tracking-[0.2em] hover:bg-white hover:shadow-[0_0_25px_rgba(190,221,125,0.6)] transition-all"
                      data-testid={`caso-cta-${caso.id}`}
                    >
                      Yo también quiero
                    </a>
                  </div>
                </div>
              </div>
            )}
          </motion.div>
        </AnimatePresence>

        {/* Arrows */}
        <div className="mt-8 flex items-center justify-center gap-3">
          <button
            onClick={prev}
            className="w-11 h-11 rounded-full border border-[#3E4D36] text-white/70 hover:text-[#BEDD7D] hover:border-[#BEDD7D]/60 flex items-center justify-center transition-all"
            data-testid="caso-prev"
            aria-label="Caso anterior"
          >
            <ChevronLeft className="w-5 h-5" />
          </button>
          <div className="text-xs font-display uppercase tracking-widest text-white/40">
            {activeIdx + 1} / {CASOS.length}
          </div>
          <button
            onClick={next}
            className="w-11 h-11 rounded-full border border-[#3E4D36] text-white/70 hover:text-[#BEDD7D] hover:border-[#BEDD7D]/60 flex items-center justify-center transition-all"
            data-testid="caso-next"
            aria-label="Siguiente caso"
          >
            <ChevronRight className="w-5 h-5" />
          </button>
        </div>
      </div>
    </section>
  );
}
